// extracted by mini-css-extract-plugin
module.exports = {"danger":"CalendarDeleteModal_danger__Guogf"};